import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import './Admin.css';

export default function AdminReportsPage() {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('pending');

    const load = () => {
        setLoading(true);
        API.get(`/api/admin/reports?status=${filter}`)
            .then(res => setReports(res.data.reports || []))
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    const handleAction = async (reportID, status, banReason = '') => {
        await API.put(`/api/admin/reports/${reportID}`, { status, ban_reason: banReason });
        load();
    };

    return (
        <div className="admin-page">
            <header className="admin-header">
                <h1>Reports Queue</h1>
                <div className="filter-tabs">
                    {['pending', 'reviewed', 'action_taken', 'dismissed'].map(s => (
                        <button
                            key={s}
                            className={`filter-tab ${filter === s ? 'active' : ''}`}
                            onClick={() => setFilter(s)}
                        >
                            {s.replace('_', ' ')}
                        </button>
                    ))}
                </div>
            </header>

            {loading ? <div className="admin-loading">Loading...</div> : (
                <div className="reports-list">
                    {reports.length === 0 && <p className="empty">No {filter} reports.</p>}
                    {reports.map(report => (
                        <div key={report.id} className="report-card">
                            <div className="report-meta">
                                <span className="report-reason">{report.reason}</span>
                                <span className="report-date">{new Date(report.created_at).toLocaleDateString()}</span>
                            </div>
                            <p><strong>Reporter:</strong> {report.reporter_email}</p>
                            <p><strong>Reported:</strong> {report.reported_email}</p>
                            {report.details && <p className="report-details">{report.details}</p>}

                            {filter === 'pending' && (
                                <div className="report-actions">
                                    <button
                                        className="btn-dismiss"
                                        onClick={() => handleAction(report.id, 'dismissed')}
                                    >
                                        Dismiss
                                    </button>
                                    <button
                                        className="btn-review"
                                        onClick={() => handleAction(report.id, 'reviewed')}
                                    >
                                        Mark Reviewed
                                    </button>
                                    <button
                                        className="btn-ban"
                                        onClick={() => {
                                            const reason = window.prompt('Ban reason:');
                                            if (reason) handleAction(report.id, 'action_taken', reason);
                                        }}
                                    >
                                        Ban User
                                    </button>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}